import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Offer } from '../../../../models/offer.model';
import { PricingUnitEnum } from '../../../../models/enums/pricing-unit.enum';
import { PricingItemScope } from '../../../../models/enums/pricing-item-scope.enum';
import { TranslateDirective } from '../../../../directives/translate.directive';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { NgIf } from '@angular/common';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { BaryIconComponent } from '../../components/bary-icon/bary-icon.component';

@Component({
  selector: 'jhi-upload-pricing-how-to',
  templateUrl: './upload-pricing-how-to.component.html',
  standalone: true,
  imports: [TranslateDirective, MDBBootstrapModulesPro, NgIf, BaryIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadPricingHowToComponent {
  @Input() offer?: Offer;
  @Input() showTitle: boolean = true;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public getMeasureUnit(): PricingUnitEnum | undefined {
    if (this.offer) {
      return this.offer.measureUnit ?? undefined;
    }
    return undefined;
  }

  public isRangePricing(): boolean {
    return PricingItemScope.RANGE === this.offer?.itemScope;
  }

  public isLDMUnit(): boolean {
    return PricingUnitEnum.LDM === this.getMeasureUnit();
  }

  public isKmUnit(): boolean {
    return PricingUnitEnum.KILOMETER === this.getMeasureUnit();
  }
}
